import customAxios from '../interceptors';

const deleteTenant = (tenantID: string) => {
  return customAxios.delete(`${process.env.REACT_APP_API_URL}/tenants/${tenantID}`);
}

export default deleteTenant;
